module.exports = __webpack_public_path__ + "img/imagen7.5c9a9cd4.png";